import { Component, Inject, Input, OnInit, OnDestroy } from '@angular/core';
import { FormControl, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Constant } from 'src/app/constant/constant';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { LeadActivityService } from 'src/app/services/lead-activity.service';
import { UsersService } from 'src/app/services/users.service';
import { takeUntil, filter } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { TransferLeadService } from 'src/app/services/transfer-lead.service';
import { conditionalValidator } from '../utils/calsoft-validators';
import { EcryptServiceService } from 'src/app/services/ecrypt-service.service';

@Component({
  selector: 'calsoft-transfer-lead',
  templateUrl: './transfer-lead.component.html',
  styleUrls: ['./transfer-lead.component.scss']
})
export class TransferLeadComponent implements OnInit, OnDestroy {

  sanitizedUrl: string = '';


  url = '';



  firstFormGroup: UntypedFormGroup;

  id: any;
  text: string;
  data: any;
  @Input() type: any;
  activityId: number;


  activityType: any;
  ownerId: any;

  typeData: any = 1;
  ownerIds: any = [];
  randomAssign: any = 0;
  enableReason: boolean = false;
  urlNew: string;
  constructor(
    private dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) data,
    private _formBuilder: UntypedFormBuilder,
    private snackBar: MatSnackBar,
    private router: Router,
    private dialogRef: MatDialogRef<TransferLeadComponent>,
    private leadActivityService: LeadActivityService,
    private usersService: UsersService,
    private transferLeadService: TransferLeadService,
    private route: ActivatedRoute,
    private ecryptService: EcryptServiceService,
  ) {

    this.data = data;

    this.urlNew = "leadTransfer";
    this.typeData = data['typeData'];
    this.randomAssign = data['randomAssign'];
    if (this.typeData == 2) {
      this.ownerIds = data['ownerIds'];
      this.urlNew = "leadTransferMultiple";
    } else {
      this.ownerId = data['ownerId'];
    }
    this.url = this.router.url || '';
    this.router.events
      .pipe(filter((e: any) => e instanceof NavigationEnd), takeUntil(this._onDestroy))
      .subscribe(() => { this.url = this.router.url || ''; });
  }

  leadId: any;

  enableTransferReason: any = 0;

  ngOnInit(): void {

    this.getAllCrmData();

    this.initActivity();

    if (this.typeData == undefined) {
      this.typeData = 1
    }

    if (this.typeData == 2) {

      this.firstFormGroup.value.leadIds = this.data['leadIds'];
      this.firstFormGroup.patchValue(this.firstFormGroup.value);
    } else {
      this.firstFormGroup.get("leadId").setValue(this.data['leadId']);
    }

    this.text = "Save";
    this.getUserDropDownList();
    this.usertypeYFilter();

  }

  getAllCrmData() {

    const encryptedData = localStorage.getItem('crmSettingsData');
    if (encryptedData) {
      try {
        const decrypted = this.ecryptService.decryptionAES(encryptedData);
        const data = JSON.parse(decrypted);

        if (data != null) {

          if (data['enableTransferReason'] != undefined) {
            this.enableTransferReason = data['enableTransferReason'];
          } else {
            this.enableTransferReason = 0;
          }


        } else {

          this.enableTransferReason = 0;

        }

      } catch (error) {
      }
    }
  }

  initActivity() {
    this.firstFormGroup = this._formBuilder.group({
      id: [0],
      leadId: [''],
      userFromId: [''],
      userFromName: [''],
      userToId: ['',
        conditionalValidator(() => this.randomAssign === 0, Validators.required),
      ],

      userToName: [''],
      transferMessage: [''],
      leadIds: this._formBuilder.array([]),
      randomAssign: this.randomAssign == undefined ? 0 : this.randomAssign,
      ownerMultiCtrl: new UntypedFormControl(),
      ownerId: this._formBuilder.array([]),
    });
  }


  editlead(lead: any) {

    this.firstFormGroup = this._formBuilder.group({
      id: lead.id,
      leadId: lead.leadId,
      userFromId: lead.userFromId,
      userFromName: lead.userFromName,
      userToId: lead.userToId,
      userToName: lead.userToName,
      transferMessage: lead.transferMessage,
      randomAssign: this.randomAssign == undefined ? 0 : this.randomAssign
    })


  }







  close() {
    this.dialogRef.close({ event: 'close' })
  }



  //user Group

  public typeYFilterControl: UntypedFormControl = new UntypedFormControl();

  defaultLeadOwner: FormControl = new FormControl('');

  protected _onDestroy = new Subject<void>();

  userTypeList: any;
  userList: any;
  filtereduserTypeList: any;

  getUserDropDownList() {

    this.usersService.getAllUserStatusDropDown().subscribe(
      res => {
        this.userList = res;

        if (this.typeData == 1) {
          let index = this.userList.findIndex(x => x.entityId == this.ownerId)
          this.userList.splice(index, 1);
        } else {
          this.ownerIds.forEach(ownerList => {

            let index = this.userList.findIndex(x => x.entityId == ownerList.ownerId)

            if (index > -1) {
              this.userList.splice(index, 1);
            }

          });
        }


        this.userTypeList = res;
        this.filtereduserTypeList = this.userTypeList;
      },
      error => {
      })
  }

  usertypeYFilter() {
    this.typeYFilterControl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.usertypeidYFilter();
      });
  }


  protected usertypeidYFilter() {
    if (!this.userTypeList) {
      return;
    }
    let search = this.typeYFilterControl.value;
    if (!search) {
      this.filtereduserTypeList = this.userTypeList.slice();
      return;
    } else {
      search = search.toLowerCase();
    }
    // filter the banks
    this.filtereduserTypeList = this.userTypeList.filter(user => user['email'].toLowerCase().indexOf(search) > -1)
  }


  listOfOwner: any = [];
  selectOwner(event, values) {
    if (event.isUserInput != false) {
      if (event.source._selected) {
        this.listOfOwner.push(event.source.value);
        this.firstFormGroup.get("ownerMultiCtrl").patchValue(this.listOfOwner);
        // this.firstFormGroup.value.profile.push(values);
      } else {
        let index = this.listOfOwner.findIndex(x => x == event.source.value)
        this.listOfOwner.splice(index, 1);
        this.firstFormGroup.get("ownerMultiCtrl").patchValue(this.listOfOwner);
        // this.firstFormGroup.value.profile.splice(index, 1);
      }
    }
  }

  checkTransferReasonEnable(event) {
    if (event.isUserInput != false) {

      if (this.enableTransferReason == 1) {
        this.enableReason = true;
      } else {
        this.enableReason = false;
      }

    }
  }


  submit() {


    if (this.text == 'Save' && this.firstFormGroup.valid) {

      if (this.id != 0) {
        this.firstFormGroup.value.operationType = "Change"
      }
      else {
        this.firstFormGroup.value.operationType = "New"
      }

      if (this.typeData == 2) {

        this.firstFormGroup.value.leadIds = this.data['leadIds'];

        this.firstFormGroup.value.ownerId = this.listOfOwner;
      }

      this.text = "Processing"
      this.transferLeadService[this.urlNew](this.firstFormGroup.value).subscribe(
        (response) => {

          if (this.typeData == undefined) {
            this.typeData = 1
          }

          if (response['status_code'] == Constant.RESPONSE_SUCCESS && this.typeData == 1) {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });


            this.dialogRef.close({ event: 'add' })

          } else if (this.typeData == 2) {
            if (response['Failed'].length == 0) {
              this.snackBar.open("Owner Changed Successfully", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

              this.dialogRef.close({ event: 'add' })
            } else {
              this.snackBar.open("Owner Changed Some Failed", '×', { panelClass: 'success', verticalPosition: 'bottom', duration: 500 });

              this.dialogRef.close({ event: 'add' })
            }
          }
          else {
            this.text = "Save";
            this.snackBar.open(response['status_message'], '×', { panelClass: 'error', verticalPosition: 'bottom', duration: 500 });
          }
        },
        (err) => { this.text = "Save" });
    }
    else {
      this.firstFormGroup.markAllAsTouched();
    }
  }



  sanitizeUrl(u: string): string {
    return (u || '')
      .replace(/^\/+/, '')
      .replace(/[?#&=]/g, '-')
      .replace(/[^a-zA-Z0-9_-]+/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '')
      .toLowerCase();
  }

  ngOnDestroy() {
    this._onDestroy.next();
    this._onDestroy.complete();
  }
}

